export default __webpack_public_path__ + "static/LaRepubblica-dfb660b40ed0608e618e63da3058e27e.svg";